import { render, staticRenderFns } from "./ScheduledNotificationTable.vue?vue&type=template&id=5bf0f68a&"
import script from "./ScheduledNotificationTable.vue?vue&type=script&lang=js&"
export * from "./ScheduledNotificationTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
